import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=649376bc&scoped=true"
import script from "./coming-soon.vue?vue&type=script&lang=js"
export * from "./coming-soon.vue?vue&type=script&lang=js"
import style0 from "./coming-soon.vue?vue&type=style&index=0&id=649376bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649376bc",
  null
  
)

export default component.exports